import { http } from '@/services/http'

export default {
  getList() {
    return http.get('/countries')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/countries.js